"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const Error_1 = __importDefault(require("@mui/icons-material/Error"));
const useChannel_1 = require("./useChannel");
const useEventHandler_1 = require("./useEventHandler");
const ChatDetail_1 = __importDefault(require("./ChatDetail"));
const ClientChatWrapper = styled_components_1.default.div `
  height: 100%;
`;
const ClientChat = ({ accountId, isOnline }) => {
    const [messages, setMessages] = (0, react_1.useState)([]);
    const [toast, setToast] = (0, react_1.useState)("");
    const updateSize = () => {
        const scrollElement = document.querySelector(".scroll-root");
        if (scrollElement) {
            scrollElement.scrollTop = scrollElement.scrollHeight;
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener("resize", updateSize);
        updateSize();
        return () => window.removeEventListener("resize", updateSize);
    }, [messages]);
    const chatChannel = (0, useChannel_1.useChannel)(`guest:${accountId}`, undefined, (channel) => {
        (0, useChannel_1.sendMessage)(channel, "message:list", {}).then(setMessages, () => {
            setMessages([]);
        });
    });
    (0, useEventHandler_1.useEventHandler)(chatChannel, "message:received", (message) => {
        setMessages([...messages, message]);
    });
    const handleMessageSend = ({ text, internal, close, setInput }) => {
        const data = {
            text,
            internal,
            close,
        };
        (0, useChannel_1.sendMessage)(chatChannel, "message:sent", data).then(() => {
            setInput("");
        }, () => {
            setToast("Could not send message");
        });
    };
    const hideToast = () => {
        setToast("");
    };
    return (react_1.default.createElement(ClientChatWrapper, null,
        react_1.default.createElement(ChatDetail_1.default, { isOnline: isOnline, messages: messages, onSend: handleMessageSend }),
        react_1.default.createElement(material_1.Snackbar, { onClose: hideToast, autoHideDuration: 4000, open: Boolean(toast), message: toast, anchorOrigin: {
                vertical: "bottom",
                horizontal: "center",
            }, className: "snackbar", action: react_1.default.createElement(Error_1.default, { fontSize: "small" }) })));
};
exports.default = ClientChat;
